import { Grid, List } from "react-feather";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { setGridView } from "../../../reduxToolkit/reducers/bookmarkTabsSlice";
import { Href } from "../../../constants";
import { Link } from "react-router-dom";

// This component provides toggle options to switch between grid view and list view for displaying bookmarks.
const ViewBookmark = () => {
  const dispatch = useAppDispatch();
  return (
    <ul>
      <li>
        <Link to={Href}>
          <Grid onClick={() => dispatch(setGridView(true))} />
        </Link>
      </li>
      <li>
        <Link to={Href}>
          <List onClick={() => dispatch(setGridView(false))} />
        </Link>
      </li>
    </ul>
  );
};
export default ViewBookmark;
